import useRosterJobPolling from "./hooks/useCreateRosterJob";

export default function RosterPolling() {
  const { data: jobStatus, isLoading } = useRosterJobPolling();

  // QUEUED: 폴링 중, SUCCESS: 완료, FAILED: 실패
  // if (isLoading) {
  //   console.log("로딩 중...");
  // } else if (jobStatus?.status === "QUEUED") {
  //   console.log(`폴링 중... progress: ${jobStatus.progress}%`);
  // } else if (jobStatus?.status === "SUCCESS") {
  //   console.log("완료!", jobStatus.result_roster_id);
  // } else if (jobStatus?.status === "FAILED") {
  //   console.log("실패:", jobStatus.error_message);
  // }

  return null;
}
